import TTMAllFacilitiesForm from "./TTMAllFacilitiesForm.vue";
export default TTMAllFacilitiesForm;